<template>
  <div class="main">
    <Scroll id="scrollContainer" loading-text="Loading...." :distance-to-edge="[0,0]" :on-reach-bottom="handleReachBottom" :height="carouselHeight + 50">
    <!-- <img class="logoImg" :src="logoPic"> -->
    <nav-header></nav-header>
    <!-- 大图  dots="none"-->
    <Carousel v-model="carouselActive" loop>
      
      <CarouselItem v-for="(item, index) in carouselItems" :key="index">
        <div :style='{background:" url("+ item.bannerUrl +") no-repeat", height: carouselHeight + "px"}' class="demo-carousel DivImage">
          <div v-if="index == 0" class="mainInfos" :style="{left: (carouselWidth*0.5 - 14) + 'px'}">
            <h1>15 YEARS ARCHITECTURAL VISUALIZATION</h1>
            <img class="logoImg" :src="logoPic">
          </div>
        </div>
      </CarouselItem>
    </Carousel>

    <!-- <swiper :options="swiperOption1">
      <swiper-slide v-for="(item, index) in carouselItems" :key="index">
        <div :style='{background:" url("+ item +") no-repeat", height: carouselHeight + "px"}' class="demo-carousel DivImage"></div>
      </swiper-slide>
    </swiper> -->

    <!-- pic group -->
    <div class="FTG-Menu imgNav">
      <Layout>
        <Header>
          <Menu mode="horizontal" theme="dark" active-name="all" @on-select="menuSelect">
            <div class="layout-nav SelectNone">
              <MenuItem name="all">All</MenuItem>
              <MenuItem name="1">Still Image</MenuItem>
              <MenuItem name="2">Animation</MenuItem>
              <MenuItem name="3">VR | AR</MenuItem>
              <div class="Clear"></div>
            </div>
          </Menu>
        </Header>
      </Layout>
    </div>

    <!-- images -->
    <div v-show="false" class="ViewPic" v-viewer="{'title': false,'toolbar': false,'movable': false,'zoomable': false}">
      <img v-for="(list, index) in ViewPicLists" :src="list.photoUrl">
    </div>

    <!-- videos -->
    <div @click="showVideos = false" class="videoViewer" :style="{display: showVideos ? 'block' : 'none'}">
      <div class="btnBox"><Icon type="md-close" /></div>
    </div>
    <video-player v-if="showVideos ? true : false" class="VideosPlay" :videoCoverUrl="video_CoverUrl" :videoSrc="video_Url"></video-player>
    
    <waterfall :col='imagesCol' :data="imageItems" :gutterWidth="10" class="image-box">
      <template>
        <div class="cell-item" v-for="(item,index) in imageItems">
           <!-- v-if="index != 1" -->
          <!-- <video-player v-if="item.type == '1'" :videoCoverUrl="item.coverUrl" :videoSrc="item.videoUrl"></video-player> -->

          <img @click="addViewPics(item.galleryId, item.type, item.videoUrl, item.coverUrl)" :style="{width: '100%'}" v-lazy="item.coverUrl ? item.coverUrl : item.defaultUrl" ondragstart="return false">
            <div @click="addViewPics(item.galleryId, item.type, item.videoUrl, item.coverUrl)" class="iconPlay" v-if="item.type == '1'">
              <Icon type="md-play" />
            </div>
          </img>
          

          <div class="item-body" :style="{color: '#000'}">
            <div class="item-desc">
              <p :style="{textOverflow: 'ellipsis',overflow: 'hidden',display: 'inline-block', width: '90%'}">
                {{item.galleryName}} 
              </p>
              <span v-if="item.type != '1'" :style="{float: 'right', fontSize: '12px'}">
                {{item.photoNum}}
                <Icon :style="{marginLeft: '5px'}" type="md-albums" />
              </span>
              <span v-if="item.type == '1'" :style="{float: 'right', fontSize: '16px'}">
                <Icon :style="{marginLeft: '5px'}" type="md-videocam" />
              </span>
            </div>
          </div>
        </div>
        
      </template>
    </waterfall>
    <!-- <infinite-loading @infinite="onInfinite">
      <span slot="no-more">
        no more data
      </span>
    </infinite-loading> -->

    <p v-if="isNoData" class="noMore">No more data...</p>
    

    <!-- <BackTop></BackTop> -->
    </Scroll>
  </div>
</template>

<script>
import NavHeader from '../components/mainHeader.vue'
import VideoPlayer from '../components/video.vue'
import logoPic from '../assets/image/FTG-logo.png'

import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';





// import InfiniteLoading from 'vue-infinite-loading';

export default {
  name: 'Main',
  components: {
    NavHeader, VideoPlayer,
    Swiper
  },
  data () {
    return {
      video_Url: '',
      video_CoverUrl: '',
      showVideos: false,

      logoPic: logoPic,
      pageWidth: window.innerWidth,  // document.body.clientWidth
      imagesCol: null,
      carouselActive: 0,
      carouselHeight: parseInt(window.innerHeight) - 50,
      carouselWidth: parseInt(window.innerWidth),
      // 首页大图
      carouselItems: [],

      // 加载图片
      isNoData: false,
      imageItems: [],
      count: 1,
      totalCount: null,
      typeActive: 'all',
      swiperOptions: {
        loop: true,
        observer: true,
        observeParents: true
      },
      ViewPicLists: [],
      canGetApi: true,
      PageSize: 10  // 每次请求条数
    }
  },
  methods: {
    //改变type
    menuSelect(val){
      this.typeActive = val
      this.count = 1
      this.imageItems = []
      this.getAlbumList()
    },
    // 获取banner
    getBannerList(){
      const that = this
      let Data = {
        
      }
      that.$api.getBannerList(Data).then(res => {
        if(res.rescode == 0){
          if(Array.isArray(res.list) && res.list.length != 0){
            that.carouselItems = res.list
          }
        }else{
          that.$Message.error(res.msg);
        }
      }).catch(err => {});
    },
    // 获取相册列表
    getAlbumList(){
      const that = this
      that.canGetApi = false
      let Data = {
        pageNo: that.count,
        pageSize: that.PageSize
      }
      if(that.typeActive != 'all'){
        Data.galleryTypeId = parseInt(that.typeActive)
      }

      that.$api.getAlbumList(Data).then(res => {
        if(res.rescode == 0){
          that.imageItems = []
          that.imageItems = res.list
          that.totalCount = res.size
          if(that.imageItems.length == res.size){
            that.isNoData = true
          }else{
            that.isNoData = false
          }
        }else{
          that.$Message.error(res.msg);
        }
        that.canGetApi = true
      }).catch(err => {that.canGetApi = true});
    },
    // 返回图片列数
    getCol(_width){
      if(_width > 1100){
        return 3
      }else if(_width < 1100 && _width > 800){
        return 2
      }else {
        return 1
      }
    },
    // 查看图片
    openImgView1(_index){
      const viewer = this.$el.querySelector('.imgViewer' + _index).$viewer
      viewer.show()
    },
    openImgView2(){
      const viewer = this.$el.querySelector('.ViewPic').$viewer
      viewer.show()
    },
    openVideoViewer(){
      const viewer = this.$el.querySelector('.videoViewer').$viewer
      viewer.show()
    },
    addViewPics(_id, type, videoUrl, coverUrl){
      const that = this
      if(type == '1'){  // video
        that.showVideos = true
        that.video_Url = videoUrl
        that.video_CoverUrl = coverUrl
      }else{
        let Data = {
          galleryId: _id
        }
        that.$api.getPicListAll(Data).then(res => {
          if(res.rescode == 0){
            that.ViewPicLists = res.list
            setTimeout(function(){
              that.openImgView2()
              var obj=document.querySelector('.viewer-container');
              obj.setAttribute('oncontextmenu','self.event.returnValue=false');
            },100)
          }else{
            that.$Message.error(res.msg);
          }
        }).catch(err => {});
      }
    },
    // 加载更多old
    onInfinite($state){
      const that = this
      if(that.imageItems.length === that.totalCount){
        $state.complete();
        return false
      }
      
      setTimeout(() => {
          // 获取图片
          let Data = {
            pageNo: that.count,
            pageSize: that.PageSize
          }
          if(that.typeActive != 'all'){
            Data.galleryTypeId = parseInt(that.typeActive)
          }

          that.$api.getAlbumList(Data).then(res => {
            if(res.rescode == 0){
              that.count += 1
              that.totalCount = res.size
              that.imageItems.push(...res.list)
              $state.loaded();
            }else{
              that.$Message.error(res.msg);
            }
          }).catch(err => {});
        }, 2000);

    },
    handleReachBottom(){
      const that = this
      if(that.imageItems.length === that.totalCount){
        return false
      }
      if(!that.canGetApi){
        return false
      }
      return new Promise(resolve => {
        setTimeout(() => {
          that.isNoData = false
          that.count ++
          // 获取图片
          let Data = {
            pageNo: that.count,
            pageSize: that.PageSize
          }
          if(that.typeActive != 'all'){
            Data.galleryTypeId = parseInt(that.typeActive)
          }

          that.$api.getAlbumList(Data).then(res => {
            if(res.rescode == 0){
              that.canGetApi = false
              // that.imageItems.push(...res.list)
              that.imageItems = that.imageItems.concat(res.list)

              // that.totalCount = res.size

              if(that.imageItems.length == res.size){
                that.isNoData = true
              }else{
                that.isNoData = false
              }
            }else{
              that.$Message.error(res.msg);
              that.isNoData = true
              
            }
            that.canGetApi = true
          }).catch(err => {that.canGetApi = true});
          resolve();
        }, 2000);
      });
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted() {
    const that = this

    eventBus.$on('alls', function () {
      that.typeActive = 'all'
      that.getAlbumList()
    });
    eventBus.$on('still', function () {
      that.typeActive = '1'
      that.getAlbumList()
    });
    eventBus.$on('animat', function () {
      that.typeActive = '2'
      that.getAlbumList()
    });
    eventBus.$on('arvr', function () {
      that.typeActive = '3'
      that.getAlbumList()
    });


    window.onresize = () => {
      return (() => {
        window.screenWidth = window.innerWidth;  //document.body.clientWidth
        that.pageWidth = window.screenWidth
      })()
    }
    that.imagesCol = that.getCol(window.innerWidth)  //document.body.clientWidth
  
       
    
    setTimeout(function(){
      new Swiper ('.swiper-container', {
        pagination: {
          el: '.swiper-pagination',
          clickable :true
        },
        loop: false,
        observer: true,
        observeParents: true
      })
    }, 100)
  },
  created(){
    const that = this
    that.getBannerList()
    that.getAlbumList()

    
  },
  watch: {
    pageWidth(val){
      if (!this.timer) {
        this.pageWidth = val
        this.timer = true
        let that = this
        setTimeout(function () {
          that.imagesCol = that.getCol(val)
          that.timer = false
        }, 400)
      }
    }
  }
}
</script>

<style scoped lang="less">
  @import '../assets/css/main.less';
  .swiper-pagination {
    text-align: right;
  }
  .noMore {
    text-align: center;
    font-size: 12px;
    color: #888;
    padding: 10px 0;
  }
  .mainInfos {
    position: relative;
    z-index: 999;
    top: 60%;
    transform: translate(-50%, -50%);

    h1 {
      color: #FFF;
      font-size: 46px;
      margin-bottom: 50px;
      text-align: center;
      font-weight: bolder;
    }
  }
  .logoImg {
    width: 153px;
    margin-left: calc(50% - 80px);
  }

  .videoViewer {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);
    z-index: 99999;

    .btnBox {
      background-color: rgba(0, 0, 0, 0.5);
      border-radius: 50%;
      cursor: pointer;
      height: 80px;
      overflow: hidden;
      position: fixed;
      right: -40px;
      top: -40px;
      -webkit-transition: background-color 0.15s;
      transition: background-color 0.15s;
      z-index: 999991;
      width: 80px;
      .ivu-icon {
        color: #FFF;
        font-size: 16px;
        position: relative;
        top: 46px;
        left: 18px;
      }
    }
  }

  .VideosPlay {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 60%;
    min-width: 350px !important;
    max-width: 860px !important;
    min-height: inherit !important;
    z-index: 999999;
    border: 8px solid #FFF;
    border-radius: 4px;
  }

  .iconPlay {
    position: absolute;
    top: calc(50% - 11px);
    left: 50%;
    transform: translate(-50%, -50%);

    width: 100px;
    height: 60px;
    border: 3px solid #FFF;
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.3);
    text-align: center;
    line-height: 54px;

    .ivu-icon {
      color: #FFF;
      font-size: 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/main.vue